
import { Watch, Component, Vue, toNative, mixins } from 'vue-facing-decorator'
@Component({})
export default class extends Vue {
}
